import promise from 'babel-runtime/core-js/promise';
import find from 'babel-runtime/core-js/array/find';
import fill from 'babel-runtime/core-js/array/fill';
import findIndex from 'babel-runtime/core-js/array/find-index';
import includes from 'babel-runtime/core-js/array/includes';
import startsWith from 'babel-runtime/core-js/string/starts-with';
import endsWith from 'babel-runtime/core-js/string/ends-with';

window.Promise = promise;

window.Array.prototype.find =
    window.Array.prototype.find ||
    function() {
        return find(this, arguments[0]);
    };

window.Array.prototype.fill =
    window.Array.prototype.fill ||
    function() {
        return fill(this, arguments[0]);
    };

window.Array.prototype.findIndex =
    window.Array.prototype.findIndex ||
    function() {
        return findIndex(this, arguments[0]);
    };

window.Array.prototype.includes =
    window.Array.prototype.includes ||
    function() {
        return includes(this, arguments[0]);
    };

window.String.prototype.startsWith =
    window.String.prototype.startsWith ||
    function() {
        return startsWith(this, arguments[0]);
    };

window.String.prototype.endsWith =
    window.String.prototype.endsWith ||
    function() {
        return endsWith(this, arguments[0]);
    };

if (!window.history || !window.history.pushState) {
    window.history.pushState = function() {};
}
